import debounce from "debounce-promise";
import { getData } from "@/utils/fetch";
import { defineStore } from "pinia";
import axios from "../config";

let debouncedFetch = debounce(getData, 500);

export const useKuotaStore = defineStore({
  id: "kuota",
  state: () => ({
    kuota: {},
    userid: "",
    kuotabyuser: {},
    kuotabyweek: {},
  }),
  getters: {
    getDataKuota(state) {
      return state.kuota.data;
    },
  },
  actions: {
    async getAllKuota(params) {
      this.kuota = { loading: true };

      const dataparams = {
        limit: params?.limit || 20,
        offset: params?.offset || 0,
        order: params?.order || "userid",
        ordertype: params?.ordertype || "ASC",
      };

      try {
        const result = await debouncedFetch("kuota", dataparams);
        this.kuota = { ...result.data };
      } catch (error) {
        console.log(error);
        this.kuota = { error };
      }
    },

    async getKuotaByUser(iduser) {
      if (iduser) {
        this.userid = iduser;

        this.kuotabyuser = { loading: true };

        try {
          const result = await debouncedFetch(`kuota/${iduser}`);
          this.kuota = { ...result.data };
        } catch (error) {
          console.log(error);
          this.kuota = { error };
        }
      }
    },

    async cekKuotaMingguan(iduser) {
      if (iduser) {
        this.userid = iduser;

        this.kuotabyweek = { loading: true };

        try {
          const result = await debouncedFetch(`kuota/cek/${iduser}`);
          this.kuotabyweek = { ...result.data };
        } catch (error) {
          console.log(error);
          this.kuotabyweek = { error };
        }
      }
    },

    async addKuota(tanggal, userid) {
      try {
        await axios.post("kuota", {
          tanggal: tanggal,
          userid: userid,
        });
        console.log("kuota added");
      } catch (error) {
        console.log(error);
      }
    },
  },
});
